import { COMPONENT_IDS } from "../storage2ComponentIDs";
class RemovedRightSideUnitComponent {
    constructor(sideUnitRef) {
        this.sideUnitRef = sideUnitRef;
        this.typeId = RemovedRightSideUnitComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
        this.name = "RemovedRightSideUnitComponent";
    }
    serializationKey() {
        return RemovedRightSideUnitComponent.componentSerializationKey;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    eq(other) {
        return other.sideUnitRef === this.sideUnitRef;
    }
}
RemovedRightSideUnitComponent.id = COMPONENT_IDS.REMOVE_RIGHT_SIDE_UNIT_ID;
RemovedRightSideUnitComponent.componentSerializationKey = "RemovedRightSideUnitComponent";
export default RemovedRightSideUnitComponent;
